import { Role } from '@/services/authentication/authentication.types';
import { FC, HTMLAttributes } from 'react';
import { FiBell, FiCalendar, FiClock, FiSettings, FiUser } from 'react-icons/fi';
import { ClockPopover } from '../../components/clock/ClockPopover';
import { TenantLogo } from '../../components/shared/TenantLogo';
import {
  isAdmin,
  isNotAdminOrSuper,
  useAuthenticationService
} from '../../services/authentication/authentication-service';
import { Feature } from '../../services/backstage/Feature';
import { ContentContainer } from './ContentContainer';
import strings from './home.translations';
import { QuickLink } from './QuickLink';

interface HomeQuickLinksProps extends HTMLAttributes<HTMLDivElement> {}

export const HomeQuickLinks: FC<HomeQuickLinksProps> = () => {
  const [role] = useAuthenticationService(state => [state.role]);

  return (
    <ContentContainer className="flex flex-col h-auto md:h-[100vh] p-7 bg-primary-std border-primary-std border rounded-lg">
      <TenantLogo />
      <div className="flex flex-col gap-2 py-5 mb-5">
        <Feature name="respect">
          {role !== Role.SuperAdmin && (
            <QuickLink url={`/ess/my-profile`} label={strings.quickLinks.myProfile} icon={<FiUser />} />
          )}
        </Feature>
        {isNotAdminOrSuper(role) && (
          <>
            <Feature name="roster">
              <QuickLink url={`/ess/my-calendar`} label={strings.quickLinks.calendar} icon={<FiCalendar />} />
            </Feature>
            <Feature name="roster">
              <QuickLink url={`/ess/my-schedule`} label={strings.quickLinks.availabilitySchedule} icon={<FiClock />} />
            </Feature>
            <Feature name="requests">
              <QuickLink url={`/ess/requests`} label={strings.quickLinks.requests} icon={<FiBell />} />
            </Feature>
          </>
        )}
        <Feature name="devices">
          {isAdmin(role) && (
            <QuickLink url={'/manage-organisation'} label={strings.quickLinks.manageOrg} icon={<FiSettings />} />
          )}
        </Feature>
      </div>
      <Feature name="clockIn">
        <>
          <ClockPopover />
        </>
      </Feature>
    </ContentContainer>
  );
};
